export const FAV_RECOMMEND_KEY = "banana_fav_recommend";
export const FAV_CHARACTER_KEY = "banana_fav_character";

export function getFavorites(key: string): string[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : [];
  } catch {
    return [];
  }
}

export function isFavorite(key: string, id: string): boolean {
  return getFavorites(key).includes(id);
}

export function toggleFavorite(key: string, id: string): { favorites: string[]; added: boolean } {
  const current = getFavorites(key);
  const exists = current.includes(id);
  const next = exists ? current.filter((v) => v !== id) : [...current, id];
  try {
    window.localStorage.setItem(key, JSON.stringify(next));
  } catch {
    // 存储不可用时静默失败，仅影响演示效果
  }
  return { favorites: next, added: !exists };
}